import { render, staticRenderFns } from "./EmailForm.vue?vue&type=template&id=c360596c&scoped=true"
import script from "./EmailForm.vue?vue&type=script&lang=js"
export * from "./EmailForm.vue?vue&type=script&lang=js"
import style0 from "./EmailForm.vue?vue&type=style&index=0&id=c360596c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c360596c",
  null
  
)

export default component.exports